/// <reference path="WebService.ts" />

interface WebService
{
    translate( text:string, languages:string[], completion:any ) : void ;    
}

WebService.prototype.translate = function( text:string, languages:string[], completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/deepl/translate";
    let body = { "Text": text, "Languages" : languages };
    let r = new DLRequest ( url_str, body, "POST" );~
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }

        if (completion) completion(json, error);
    } );
}
